import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";


import riz1 from './../media/img/riz4.jpg'
import riz2 from './../media/img/riz5.jpg'
import riz3 from './../media/img/riz6.jpg'
import riz4 from './../media/img/riz7.jpg'
import riz1_v from './../media/img/riz1.mp4'
import riz2_v from './../media/img/riz2.mp4'
import riz3_v from './../media/img/riz3.mp4'

import gr1 from './../media/img/gr1.jpeg'
import gr2 from './../media/img/gr2.jpeg'
import gr3 from './../media/img/gr3.jpeg'
import gr4 from './../media/img/gr4.jpg'
import gr5 from './../media/img/gr5.jpeg'
import gr6 from './../media/img/gr6.jpeg'
import gr7 from './../media/img/gr7.jpeg'
import gr8 from './../media/img/gr8.jpeg'

import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import ds_logo from './../media/img/ds-logo.png'
import tt_logo from './../media/img/tik-tok.png'

import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import bm1 from './../media/img/bm1.jpg'
import bm2 from './../media/img/bm2.jpg'

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="main-frame height_100_p">
                    <div className="flex row align-center justify-center height_100_p">
                        <div className="home-text flex column justify-flex-end height_100_p">
                            {/* <img src={bwog_logo} className="home-text-logo-ant" alt="" data-aos="zoom-in" data-aos-duration="2000" /> */}
                            {/* <div className="home-head-subhead" data-aos="fade-right" data-aos-duration="2000">
                                <h2>$BWOGG</h2>
                                <h3 className="text-align-center">The Meme Coin Nobody Asked For, But Everyone Needs!</h3>
                            </div> */}
                            <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                <a href="https://x.com/GeorgieOnSOL_" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={x_logo} alt="" />
                                </a>
                                <a href="https://t.me/georgiesol" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tg_logo} alt="" />
                                </a>
                                <a href="https://dexscreener.com/solana/6dt8wxe2xvytsyk7d2799yinufakpj1rwbkwg6bxeopq" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={ds_logo} alt="" />
                                </a>
                                <a href="https://www.tiktok.com/@heresyourmonkeycontent" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tt_logo} alt="" />
                                </a>
                            </div>
                            {/* <div className="flex row justify-center align-center gap-5 copy-address-box" data-aos="fade-up" data-aos-duration="2000">
                                <img src={copy_icon} alt="" />
                                <p>0x760539FF254A88B925fd940C8Bc01069cf76069b</p>
                            </div> */}
                            {/* <div className="flex row gap-15" data-aos="fade-up" data-aos-duration="2000">
                                <a href="" target="_blank" className='btn-1'>
                                    Buy Now
                                </a>
                                <a href="" target="_blank" className='btn-sp'>
                                    Join Community
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="htb" id="htb">
                <div className="htb-frame">
                    <div className="htb-header">
                        <h2>Trust Georgie. The bull run is inevitable. 🔥📈</h2>
                        <h3>How to buy $GEORGIE</h3>
                    </div>
                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={phantom_logo} alt="" />
                                </div>
                                <h4>Phantom</h4>
                                <p>
                                    To swap $GEORGIE on phantom,
                                </p>
                                <a href="https://phantom.app/download" target="_blank">Click here</a>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img className="htb-ton-logo" src={sol_logo} alt="" />
                                </div>
                                <h4>Buy SOL</h4>
                                <p>
                                    Buy SOL from your phantom wallet or any centralized exchange of your choice. You can also get a friend to send you SOL
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={gr4} className="riz_img" alt="" />
                                </div>
                                <h4>Swap $GEORGIE on DEX</h4>
                                <p>
                                    Now that you have an SOL in your wallet, you can now swap SOL to GEORGIE 
                                    on <a href="https://raydium.io/swap/?utm_source=phantom&utm_medium=list&inputMint=sol&outputMint=CkwV1ZG7YrjhtfrywGTR8ukxHdqqiXPGQj3qA3xEpump" target="_blank">raydium</a> using 
                                    our Contract Address
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <seciton className="memes" id="memes">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WALL OF MEMES</h2>
                    </div>

                    <div className="wom-cont grid grid-column-3 grid-column-gap-20 grid-row-gap-20">
                        <div className="wom-item">
                            <img src={gr2} alt="" />
                        </div>
                        <div className="wom-item">
                            {/* <video src={riz1_v} autoPlay muted loop /> */}
                            <img src={gr6} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={gr5} alt="" />
                            {/* <video src={riz3_v} autoPlay muted loop /> */}
                        </div>
                        <div className="wom-item">
                            <img src={gr7} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={gr8} alt="" />
                            {/* <video src={riz2_v} autoPlay muted loop /> */}
                        </div>
                        <div className="wom-item">
                            <img src={gr3} alt="" />
                        </div>
                    </div>
                </div>
            </seciton>

            <section className="about" id="about">
                <div className="htb-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-text" data-aos="fade-right" data-aos-duration="2000">
                            {/* <h2>About Peki Inu</h2> */}
                            <h3>Let’s take this to the moon together! 🌙🚀</h3>
                            <p>
                                Georgie, the most famous monkey on the internet, is swinging into the crypto space! Inspired by viral charm and 
                                internet fame, Georgie brings fun, hype, and a sense of adventure to the world of memecoins. Join Georgie’s 
                                wild journey as we take this memecoin to the moon with a community of ape enthusiasts and crypto lovers alike. 🐒🚀 <br /><br />

                                Get ready to go bananas with Georgie!
                            </p>

                            <a href="https://x.com/GeorgieOnSOL_" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Check out Tweet</span> 
                               <img src={twitter_icon} alt="" />
                            </a>
                        </div>
                        <div className="about-img" data-aos="fade-left1" data-aos-duration="2000">
                            <img src={gr2} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="key-features">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WHY GEORGIE?</h2>
                    </div>

                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={sol_logo} alt="" />
                                </div>
                                <h4>Solana Speed</h4>
                                <p>
                                    Faster than Brett’s lunch break.
                                </p>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <div className="kf-icon-box flex justify-center align-center">
                                        <img src={com_icon} className="" alt="" />
                                    </div>
                                </div>
                                <h4>Community Vibes</h4>
                                <p>
                                    Bears try to bring us down, but Georgie got moves they can’t handle. 🐻❌
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={gr4} className="riz_img" alt="" />
                                </div>
                                <h4>Moon Potential</h4>
                                <p>
                                    Pack your bags, we’re moon-bound. 🚀
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section className="tk" id="tk">
                <div className="htb-frame">
                    <div className="cs-header" data-aos="fade-up" data-aos-duration="2000">
                        {/* <h2>Uniting the Strengths of Floki and Shiba</h2> */}
                        <h2>TOKENOMICS</h2>
                    </div>
                    <div className="grid grid-column-4 row grid-column-gap-50 grid-row-gap-20" >

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={check_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Name/Ticker</h2>
                                <h3>$GEORGIE</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={eq_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Total Supply</h2>
                                <h3>100,000,000</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={lock_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>LP Burned</h2>
                                <h3>Lp is Burned forever</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={per_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Taxes</h2>
                                <h3>0/0</h3>
                                {/* <h3>3 Marketing and Development | 1 LP</h3> */}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* <section className="roadmap" id="roadmap">
                <div className="htb-frame">
                    <div className="roadmap-header" data-aos="fade-up" data-aos-duration="2000">
                        <h3>BWOGG MAP</h3>
                    </div>

                    <div className="grid rd-item-grid row grid-column-3 grid-column-gap-30 grid-row-gap-20 overflow-y-hidden">
                        <div className="rd-item" data-aos="fade-right" data-aos-duration="2000">
                            <h3>Phase 1</h3>
                            <ul>
                                <li>Create social media awarness</li>
                                <li>Fair Launch on Pumpfun</li>
                                <li>Build community</li>
                                <li>Hold AMA Session</li>
                                <li>Hit the Ray</li>
                                <li>Launch Initial Contests and Competitions</li>
                            </ul>
                        </div>
                        
                        <div className="rd-item" data-aos="fade-up" data-aos-duration="2000">
                            <h3>Phase 2</h3>
                            <ul>
                                <li>Community Airdrop of 50M tokens</li>
                                <li>Massive meme marketing campaign</li>
                                <li>update Dexscreener</li>
                                <li>Dex Screener Ads</li>
                            </ul>
                        </div>

                        <div className="rd-item" data-aos="fade-left" data-aos-duration="2000">
                            <h3>Phase 3</h3>
                            <ul>
                                <li>#1 on SOL Trending</li>
                                <li>Fatality Volume bot</li>
                                <li>List on major platforms like dex tools and more</li>
                                <li>Continue Contests and Competitions</li>
                                <li>Continue to hold regular AMA Sessions</li>
                            </ul>
                        </div>


                    </div>
                </div>
            </section> */}

            <section className="join" id="join">
                <div className="kf-frame">
                    <div className="cs-header overflow-y-hidden" data-aos="fade-up" data-aos-duration="2000">
                        <h2>Join Smooth Moves, and Big Gains</h2>
                        {/* <p>We are supported by many people. Why don’t you join them?</p> */}
                    </div>

                    <div className="join-box">
                        <div className="flex justify-center">
                            <img src={gr3} alt="" />
                        </div>
                        <p>
                            Join the jungle with Georgie, the internet’s favorite monkey turned memecoin sensation! Be part of a fun, hyped community 
                            where we’re all aping in and getting ready to moon. Don’t miss out on the wild ride—join Georgie’s crew today! 🐒🌕
                        </p>
                        <h4>CA: CkwV1ZG7YrjhtfrywGTR8ukxHdqqiXPGQj3qA3xEpump</h4>
                        <a href="https://t.me/georgiesol" target="_blank" className="btn-1">Telegram</a>
                    </div>
                </div>
            </section>

            <section className="footer" id="footer">
                <div className="main-container">
                    
                        <div className="footer-box ">
                            <h2>GEORGIE CTO</h2>
                            <div className="flex justify-center">
                                <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                    <a href="https://x.com/GeorgieOnSOL_" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/georgiesol" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    {/* <a href="mailto:dhurovcoin@gmail.com" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={mail_icon} alt="" />
                                    </a> */}
                                    <a href="https://dexscreener.com/solana/6dt8wxe2xvytsyk7d2799yinufakpj1rwbkwg6bxeopq" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={ds_logo} alt="" />
                                    </a>
                                    <a href="https://www.tiktok.com/@heresyourmonkeycontent" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tt_logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <p className="copyright">GEORGIE copyright 2024 - All Rights Reserved</p>
                    </div>

                    {/* <hr /> */}
                </div>
            </section>

        </div>
    );
}
 
export default Home;